import React from "react"
import { FastTimeIcon } from "../utilities/resources"
import { Modal } from "antd"
import ModalBox from "./common/ModalBox"

function ComingSoonModal(props) {
  const { visible, setVisible } = props

  const handleOk = () => {
    setVisible(false)
  }

  return (
    <ModalBox title="" footer={null} visible={visible} setVisible={handleOk} width="500px">
      <div className={"comingSoonModal"}>
        <img src={FastTimeIcon} alt="" />
        <h1>Coming Soon</h1>
        <p>You have been successfully registered for the webinar. You can join the webinar 10 minutes before it starts.</p>
      </div>
    </ModalBox>
  )
}

export default ComingSoonModal
